var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { Alert, Spin, message, Modal, Button, Result } from "antd";
import { useLocation } from "react-router-dom";
import { useApplicationContext } from "../../context/application-context";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import apiClientServices from "../../api-client";
import { Block, BlockCard, BlockTitle, CommentsTextArea, FinalDecisionCard, FinalDecisionColumn, FinalDecisionBody, FinalDecisionOption, FinalDecisionOptions, FinalDecisionRow, OptionContent, OptionDescription, OptionLabel, SectionBody, SectionCard, SectionDivider, SectionHeader, SubmitButton, SubmitButtonWrapper, FeedbackOptions, FeedbackOption, Wrapper, BlockCardCommentSection, InnerWrapper, FeedbackHeaderWrapper, FeedbackInfoBar, FeedbackInfoText, FeedbackInfoName, } from "./style";
import { MANAGER_ENDPOINTS } from "../../utils/endpoints";
import { getFeedbackSubmittedByName, getManagerEmailFromContext, hydrateManagerUserFromStorage, } from "../../utils/manager-login-profile";
import FeedbackFormHeader from "../feedback-v2-header";
import QuestionsAskedList from "./QuestionsAskedList";
import InviteAdditionalHm from "../invite-additional-hm";
import NeedHelpSupport from "../need-help-support";
const sectionHasFeedbackOptions = (section) => Array.isArray(section.feedback) && section.feedback.length > 0;
const HiringFeedbackV2 = (props) => {
    var _a, _b, _c, _d;
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    // Use props if provided, otherwise fall back to search params
    const userId = props.userId || searchParams.get("id");
    const courseId = props.courseId || searchParams.get("courseId");
    const stageId = props.stageId;
    const panelInterviewId = props.panelInterviewId;
    const enableInviteAdditionalHm = props.enableInviteAdditionalHm === true;
    const { user, setUser } = useApplicationContext();
    useEffect(() => {
        hydrateManagerUserFromStorage(setUser);
    }, [setUser]);
    const [template, setTemplate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [sectionResponses, setSectionResponses] = useState({});
    const [finalDecision, setFinalDecision] = useState();
    const [finalComments, setFinalComments] = useState("");
    const [candidateName, setCandidateName] = useState("");
    const [resumeLink, setResumeLink] = useState("");
    const [candidateProfileImage, setCandidateProfileImage] = useState("");
    const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
    const [existingFeedback, setExistingFeedback] = useState(null);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [feedbackMetadata, setFeedbackMetadata] = useState(null);
    // Date formatting helper
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        const month = months[date.getMonth()];
        const year = date.getFullYear().toString().slice(-2);
        return `${day} ${month} '${year}`;
    };
    // Fetch existing feedback first
    useEffect(() => {
        const fetchExistingFeedback = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            if (!courseId || !userId) {
                return;
            }
            try {
                console.log("panelMemberId", sessionStorage.getItem("userId"));
                const response = yield apiClientServices.get(MANAGER_ENDPOINTS.GET_HM_FEEDBACK_V2, { params: { courseId, userId, panelMemberId: sessionStorage.getItem("userId") } });
                const result = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.result;
                if (result && result.feedback) {
                    setExistingFeedback(result);
                    setIsReadOnly(true);
                    setFeedbackMetadata({
                        feedbackSubmittedByName: result.feedback.feedbackSubmittedByName ||
                            result.feedback.feedbackDoneByName ||
                            "",
                        submittedAt: result.feedback.submittedAt || "",
                    });
                }
                else {
                    setExistingFeedback(null);
                    setIsReadOnly(false);
                    setFeedbackMetadata(null);
                }
            }
            catch (err) {
                // If API fails, assume no existing feedback
                console.log("err", err);
                setExistingFeedback(null);
                setIsReadOnly(false);
                setFeedbackMetadata(null);
            }
        });
        fetchExistingFeedback();
    }, [courseId, userId]);
    // Fetch template (always needed to render form structure)
    useEffect(() => {
        const fetchTemplate = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (!courseId) {
                setError("Invalid URL. Please try again.");
                return;
            }
            setLoading(true);
            setError(null);
            try {
                const response = yield apiClientServices.get(MANAGER_ENDPOINTS.GET_FEEDBACK_TEMPLATE_V2, { params: { courseId } });
                const result = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.template;
                if (result) {
                    setTemplate(result);
                }
                else {
                    throw new Error("Template not found in response");
                }
            }
            catch (err) {
                setError(err instanceof Error
                    ? err.message
                    : "Failed to load feedback template. Please try again later.");
            }
            finally {
                setLoading(false);
            }
        });
        fetchTemplate();
    }, [courseId]);
    useEffect(() => {
        const fetchUserDetailsAndProfilePhoto = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            if (!userId)
                return;
            setCandidateProfileImage("");
            try {
                const response = yield apiClientServices.get(MANAGER_ENDPOINTS.GET_USER_DETAILS, { params: { userId } });
                const result = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.result;
                if (result) {
                    setCandidateName(result.name || "");
                    setResumeLink(result.resumeLink || "");
                }
            }
            catch (err) {
                message.error("Failed to load user resume.");
            }
            if (!courseId)
                return;
            try {
                const photoResponse = yield apiClientServices.get(MANAGER_ENDPOINTS.GET_PROFILE_PHOTO_URL, { params: { userId, courseId } });
                const profilePhoto = (_c = (_b = photoResponse === null || photoResponse === void 0 ? void 0 : photoResponse.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.profilePhoto;
                const trimmedPhoto = typeof profilePhoto === "string" ? profilePhoto.trim() : "";
                setCandidateProfileImage(trimmedPhoto);
            }
            catch (_d) {
                setCandidateProfileImage("");
            }
        });
        fetchUserDetailsAndProfilePhoto();
    }, [userId, courseId]);
    // Initialize section responses from template OR populate from existing feedback
    useEffect(() => {
        if (!template)
            return;
        if (existingFeedback && existingFeedback.feedback) {
            // Populate from existing feedback
            const feedback = existingFeedback.feedback;
            const populatedResponses = {};
            template.sections.forEach((section, index) => {
                var _a, _b, _c;
                const sectionResponse = (_a = feedback.sectionResponses) === null || _a === void 0 ? void 0 : _a.find((sr) => sr.sectionTitle === section.title);
                if (sectionResponse) {
                    // Find the selected option
                    const selectedOption = (_b = sectionResponse.feedback) === null || _b === void 0 ? void 0 : _b.find((opt) => opt.isSelected === true);
                    populatedResponses[index] = {
                        score: (_c = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.score) !== null && _c !== void 0 ? _c : null,
                        comment: sectionResponse.comments || "",
                    };
                }
                else {
                    populatedResponses[index] = { score: null, comment: "" };
                }
            });
            setSectionResponses(populatedResponses);
            // Set final decision
            if (feedback.finalDecision) {
                const selectedDecision = feedback.finalDecision.find((fd) => fd.isSelected === true);
                if (selectedDecision) {
                    setFinalDecision(selectedDecision.label);
                }
            }
            // Set final comments
            if (feedback.finalComments) {
                setFinalComments(feedback.finalComments);
            }
            // Set candidate name if available
            if (feedback.candidateName) {
                setCandidateName(feedback.candidateName);
            }
        }
        else {
            // Initialize empty responses
            setSectionResponses(template.sections.reduce((acc, _, index) => {
                acc[index] = { score: null, comment: "" };
                return acc;
            }, {}));
        }
    }, [template, existingFeedback]);
    const allSectionsCompleted = useMemo(() => {
        if (!template)
            return false;
        return template.sections.every((section, index) => {
            var _a;
            if (!sectionHasFeedbackOptions(section))
                return true;
            return ((_a = sectionResponses[index]) === null || _a === void 0 ? void 0 : _a.score) !== null;
        });
    }, [sectionResponses, template]);
    // Calculate current score from selected options
    const currentScore = useMemo(() => {
        if (!template)
            return 0;
        return Object.values(sectionResponses).reduce((total, response) => {
            var _a;
            return total + ((_a = response.score) !== null && _a !== void 0 ? _a : 0);
        }, 0);
    }, [sectionResponses, template]);
    // Calculate max possible score from template
    const maxPossibleScore = useMemo(() => {
        if (!template)
            return 0;
        return template.sections.reduce((total, section) => {
            if (!sectionHasFeedbackOptions(section))
                return total;
            const maxSectionScore = Math.max(...section.feedback.map((opt) => opt.score));
            return total + maxSectionScore;
        }, 0);
    }, [template]);
    const handleScoreChange = (sectionIndex, score) => {
        setSectionResponses((prev) => (Object.assign(Object.assign({}, prev), { [sectionIndex]: Object.assign(Object.assign({}, prev[sectionIndex]), { score: Number(score) }) })));
    };
    const handleCommentChange = (sectionIndex, value) => {
        setSectionResponses((prev) => (Object.assign(Object.assign({}, prev), { [sectionIndex]: Object.assign(Object.assign({}, prev[sectionIndex]), { comment: value }) })));
    };
    const submitFeedback = () => __awaiter(void 0, void 0, void 0, function* () {
        var _e;
        if (!template)
            return;
        setIsSubmitting(true);
        const feedbackActorEmail = getManagerEmailFromContext(user);
        const feedbackSubmittedByName = getFeedbackSubmittedByName(user);
        const payload = {
            candidateName,
            sectionResponses: template.sections.map((section, index) => {
                var _a;
                return ({
                    sectionTitle: section.title,
                    competency: section.competency,
                    questionsAsked: section.questionsAsked,
                    feedback: sectionHasFeedbackOptions(section)
                        ? section.feedback.map((option) => {
                            var _a;
                            return ({
                                label: option.label,
                                description: option.description,
                                score: option.score,
                                isSelected: option.score === ((_a = sectionResponses[index]) === null || _a === void 0 ? void 0 : _a.score),
                            });
                        })
                        : [],
                    comments: ((_a = sectionResponses[index]) === null || _a === void 0 ? void 0 : _a.comment) || "",
                });
            }),
            finalDecision: template.finalDecision.map((decision) => ({
                label: decision.label,
                isSelected: decision.label === finalDecision,
            })),
            finalComments,
            feedbackDoneBy: feedbackActorEmail,
            feedbackSubmittedByName,
            feedbackSignedBy: feedbackActorEmail,
            submittedAt: new Date().toISOString(),
        };
        try {
            yield apiClientServices.post(
            // `http://localhost:7034/manual-feedback/v2/submit-hm-feedback?courseId=${courseId}&userId=${userId}`,
            `${MANAGER_ENDPOINTS.SUBMIT_HM_FEEDBACK_V2}?courseId=${courseId}&userId=${userId}`, payload);
            // Fetch the submitted feedback to show it in read-only mode
            try {
                console.log("panelMemberId in fetch submitted feedback", sessionStorage.getItem("userId"));
                const response = yield apiClientServices.get(MANAGER_ENDPOINTS.GET_HM_FEEDBACK_V2, { params: { courseId, userId, panelMemberId: sessionStorage.getItem("userId") } });
                const result = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.result;
                if (result && result.feedback) {
                    setExistingFeedback(result);
                    setIsReadOnly(true);
                    setFeedbackMetadata({
                        feedbackSubmittedByName: result.feedback.feedbackSubmittedByName ||
                            result.feedback.feedbackDoneByName ||
                            "",
                        submittedAt: result.feedback.submittedAt || "",
                    });
                    setIsSubmitting(false);
                }
            }
            catch (fetchError) {
                console.error("Failed to fetch submitted feedback:", fetchError);
                setIsSubmitting(false);
            }
            message.success("Thank you! Your feedback has been submitted.");
        }
        catch (error) {
            console.log("error in submit feedback", error);
            message.error("Failed to submit feedback. Please try again.");
            setIsSubmitting(false);
        }
    });
    const handleSubmit = () => {
        if (isReadOnly) {
            return; // Prevent submission when read-only
        }
        if (!template)
            return;
        if (!courseId || !userId) {
            message.error("Missing courseId or userId in URL.");
            return;
        }
        if (!allSectionsCompleted || !finalDecision) {
            message.warning("Please fill all mandatory selections before submitting.");
            return;
        }
        setIsConfirmModalVisible(true);
    };
    const handleConfirmSubmit = () => {
        setIsConfirmModalVisible(false);
        submitFeedback();
    };
    const handleCancelSubmit = () => {
        setIsConfirmModalVisible(false);
    };
    if (loading) {
        return (_jsx(Wrapper, { children: _jsx(Spin, {}) }));
    }
    if (error) {
        return (_jsx(Wrapper, { children: _jsx(Alert, { type: "error", message: error }) }));
    }
    if (!template) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Wrapper, { children: [_jsx(FeedbackHeaderWrapper, { children: _jsx(FeedbackFormHeader, { candidateName: candidateName, resumeLink: resumeLink, profileImage: candidateProfileImage, score: isReadOnly
                                ? ((_b = (_a = existingFeedback === null || existingFeedback === void 0 ? void 0 : existingFeedback.feedback) === null || _a === void 0 ? void 0 : _a.score) !== null && _b !== void 0 ? _b : 0)
                                : currentScore, maxScore: isReadOnly
                                ? ((_d = (_c = existingFeedback === null || existingFeedback === void 0 ? void 0 : existingFeedback.feedback) === null || _c === void 0 ? void 0 : _c.totalScore) !== null && _d !== void 0 ? _d : 0)
                                : maxPossibleScore, isReadOnly: isReadOnly, onResumeView: () => {
                                if (resumeLink) {
                                    window.open(resumeLink, "_blank", "noopener,noreferrer");
                                }
                            } }) }), enableInviteAdditionalHm && (_jsx(InviteAdditionalHm, { candidateUserId: userId || undefined, courseId: courseId || undefined, stageId: stageId, panelInterviewId: panelInterviewId })), _jsx(InnerWrapper, { children: isSubmitting ? (_jsx("div", Object.assign({ style: {
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: "400px",
                            } }, { children: _jsx(Result, { status: "success", title: "Thank you! Your feedback is being submitted...", subTitle: "Please wait while we process your feedback. You will be able to view your submitted feedback shortly.", extra: _jsx(Spin, { size: "large" }) }) }))) : (_jsxs(_Fragment, { children: [template.sections.map((section, sectionIndex) => {
                                    var _a, _b, _c;
                                    return (_jsxs(SectionCard, { children: [_jsx(SectionHeader, { children: section.title }), _jsx(SectionDivider, {}), _jsxs(SectionBody, { children: [_jsxs(Block, { children: [_jsx(BlockTitle, { children: "Questions" }), _jsx(BlockCard, { children: _jsx(QuestionsAskedList, { questionsAsked: section.questionsAsked, sectionTitle: section.title, showOrBetweenQuestions: sectionIndex === 0 }) })] }), sectionHasFeedbackOptions(section) && (_jsxs(Block, { children: [_jsx(BlockTitle, { children: "Feedback" }), _jsx(FeedbackOptions, Object.assign({ value: (_b = (_a = sectionResponses[sectionIndex]) === null || _a === void 0 ? void 0 : _a.score) !== null && _b !== void 0 ? _b : null, onChange: (event) => handleScoreChange(sectionIndex, event.target.value), disabled: isReadOnly || isSubmitting }, { children: section.feedback.map((option) => {
                                                                    var _a;
                                                                    return (_jsx(FeedbackOption, Object.assign({ value: option.score, checked: ((_a = sectionResponses[sectionIndex]) === null || _a === void 0 ? void 0 : _a.score) ===
                                                                            option.score, disabled: isReadOnly || isSubmitting }, { children: _jsxs(OptionContent, { children: [_jsx(OptionLabel, { children: option.label }), _jsx(OptionDescription, { children: option.description })] }) }), option.label));
                                                                }) }))] })), section.isCommentsEnabled && (_jsxs(Block, { children: [_jsx(BlockTitle, { children: "Comments" }), _jsx(BlockCardCommentSection, { children: _jsx(CommentsTextArea, { autoSize: { minRows: 1 }, placeholder: "Type your comment here", value: (_c = sectionResponses[sectionIndex]) === null || _c === void 0 ? void 0 : _c.comment, onChange: (event) => handleCommentChange(sectionIndex, event.target.value), readOnly: isReadOnly || isSubmitting }) })] }))] })] }, `${section.title}-${sectionIndex}`));
                                }), _jsxs(FinalDecisionRow, { children: [_jsxs(FinalDecisionCard, { children: [_jsx(SectionHeader, { children: "Final Decision" }), _jsx(SectionDivider, {}), _jsx(FinalDecisionBody, { children: _jsx(FinalDecisionColumn, { children: _jsx(FinalDecisionOptions, Object.assign({ value: finalDecision, onChange: (event) => setFinalDecision(event.target.value), disabled: isReadOnly || isSubmitting }, { children: template.finalDecision.map((decision) => (_jsx(FinalDecisionOption, Object.assign({ value: decision.label, disabled: isReadOnly || isSubmitting }, { children: decision.label }), decision.label))) })) }) })] }), template.isFinalCommentsEnabled && (_jsxs(FinalDecisionCard, { children: [_jsx(SectionHeader, { children: "Final Comments" }), _jsx(SectionDivider, {}), _jsx(FinalDecisionBody, { children: _jsx(FinalDecisionColumn, { children: _jsx(CommentsTextArea, { autoSize: { minRows: 1 }, placeholder: "Type your comment here", value: finalComments, onChange: (event) => setFinalComments(event.target.value), readOnly: isReadOnly || isSubmitting }) }) })] }))] }), isReadOnly && feedbackMetadata ? (_jsxs(FeedbackInfoBar, { children: [feedbackMetadata.feedbackSubmittedByName !== "" && (_jsxs(FeedbackInfoText, { children: ["Feedback by:", " ", _jsx(FeedbackInfoName, { children: feedbackMetadata.feedbackSubmittedByName })] })), _jsxs(FeedbackInfoText, { children: ["Submitted on: ", formatDate(feedbackMetadata.submittedAt)] })] })) : (_jsx(SubmitButtonWrapper, { children: _jsx(SubmitButton, Object.assign({ type: "primary", onClick: handleSubmit, disabled: isSubmitting, loading: isSubmitting }, { children: "Submit Feedback" })) }))] })) }), _jsx(NeedHelpSupport, {})] }), _jsx(Modal, Object.assign({ open: isConfirmModalVisible, onCancel: handleCancelSubmit, footer: null, centered: true, destroyOnClose: true }, { children: _jsxs("div", Object.assign({ style: { textAlign: "center", paddingTop: 8, paddingBottom: 8 } }, { children: [_jsx(ExclamationCircleOutlined, { style: { fontSize: 32, color: "#F7B500" } }), _jsx("h3", Object.assign({ style: { marginTop: 16, marginBottom: 8 } }, { children: "Confirm Submission" })), _jsxs("p", Object.assign({ style: { margin: 0, color: "#6B7280" } }, { children: ["You\u2019re about to submit your feedback.", _jsx("br", {}), "Once saved, it can\u2019t be edited or changed later."] })), _jsxs("div", Object.assign({ style: {
                                marginTop: 24,
                                display: "flex",
                                justifyContent: "space-between",
                                gap: 12,
                            } }, { children: [_jsx(Button, Object.assign({ onClick: handleCancelSubmit, style: { flex: 1, borderRadius: 6 } }, { children: "Cancel" })), _jsx(Button, Object.assign({ type: "primary", danger: true, onClick: handleConfirmSubmit, style: { flex: 1, borderRadius: 6 } }, { children: "Confirm" }))] }))] })) }))] }));
};
export default HiringFeedbackV2;
